module.exports = {
  platform: 'voice',
  name: 'Start',
  node: 'start',
  bg: '#FFFFFF',
  note: '',
  property: {
    tts: {
      voice: 'GG_STANDARD_A',
      speaker: 'th-TH-Standard-A',
      speed: 1,
      pitch: 1,
      dictionaries: [],
      dictionaries_name: []
    },
    flow: {
      fallback_after: 2,
      page_max_retry: '',
      page_error: '',
      page_session_ended: ''
    },
    amd: {
      enable: false,
      max_duration: 10,
      max_silence: 3,
      machine_cutoff_duration: 5
    },
    default_input: {
      beep: {
        enable: true,
        path: 'beep/Clear.wav'
      },
      is_count_retry: true,
      asr: {
        grammar_id: '',
        grammar_name: '',
        timeout: '5.00',
        complete_timeout: '0.70',
        incomplete_timeout: '1.00',
        max_speech_timeout: '15.00',
        asr_confidence_threshold: '0.00',
        voice_barge_in: false,
        voice_barge_in_sensitivity: 3,
        voice_barge_in_threshold: 1024
      },
      nlu: ''
    }
  }
}
